<ascedia-jumbotron [options]="jumbotron" *ngIf="jumbotron$ | async as jumbotron;"></ascedia-jumbotron>


<div class="container mt-5">

	<!-- <ng-container *ngIf="sliderListBg$ | async as sliderListBg; else noSliderListBg">
		<ascedia-swiper-background-image className="mb-5"
			[config]="config"
			[sliderList]="sliderListBg"
			text="Our Most Popular Destinations"
			className="overflow-visible"
			>
		</ascedia-swiper-background-image>
	</ng-container>
	<ng-template #noSliderListBg>
		<div class="my-3">No Slider List background found.</div>
	</ng-template> -->

	<ng-template #noSliderList>
		<div class="my-3">No lists found.</div>
	</ng-template>

	<ng-container *ngIf="sliderList$ | async as sliderList; else noSliderList">
		<ng-container *ngFor="let list of sliderList">
			<ascedia-swiper-background-image className="mb-5"
				[sliderList]="list.items"
				[config]="config"
				[text]="list.title"
				className="overflow-visible"
				>
			</ascedia-swiper-background-image>
		</ng-container>
	</ng-container>

</div>

<div class="container-fluid bg-gray-100">

	<div class="container py-5">
		<div class="font-family-accent text-center mb-4">
			<h5 class="text-green-pacific font-weight-bold">Discover Excursions in 100+ Countries</h5>
			<h2 class="text-headline font-weight-bold">Explore Destinations By Region</h2>
		</div>
	
		<!-- <ascedia-image-grid
			[imageGrid]="imageGrid"
			[showTitles]="true"
			className="mb-3 rounded-corners"
			></ascedia-image-grid> -->

		<ng-container *ngIf="imageGrid$ | async as imageGrid;">
			<ng-container *ngFor="let grid of imageGrid">
				<ascedia-image-grid
					[imageGrid]="grid"
					[showTitles]="true"
					className="mb-3 rounded-corners"
					></ascedia-image-grid>
			</ng-container>
		</ng-container>
		
	</div>

</div>

<ascedia-swiper-jumbotron [sliderList]="jumbotronSlider" className="is-overlay"  *ngIf="jumbotronSlider$ | async as jumbotronSlider;"></ascedia-swiper-jumbotron>

<app-safety></app-safety>
